"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectSpec = exports.notOperator = exports.comparisonOperator = exports.normalOperator = exports.logicalOperator = exports.numberChain = exports.stringOrWordOrNumber = exports.stringOrWord = exports.numberSym = exports.stringSym = exports.wordSym = exports.setValueList = exports.setValue = exports.dataType = void 0;

var _ = require("../../..");

var _reserveKeys = require("./reserve-keys");

var dataType = function dataType() {
  return (0, _.chain)([(0, _.chain)(['char', 'varchar', 'tinytext', 'text', 'mediumtext', 'longtext'])(function (ast) {
    return ast[0];
  }), (0, _.chain)(['tinyint', 'smallint', 'mediumint', 'int', 'integer', 'bigint'])(function (ast) {
    return ast[0];
  }), (0, _.chain)(['real', 'double', 'float'])(function (ast) {
    return ast[0];
  }), (0, _.chain)(['decimal', 'numberic'])(function (ast) {
    return ast[0];
  }), (0, _.chain)(['date', 'tinyblob', 'blob', 'mediumblob', 'longblob', 'bool', 'boolean'])(function (ast) {
    return ast[0];
  }), (0, _.chain)(['bit', 'time', 'timestamp', 'datetime', 'binary', 'varbinary', 'year'])(function (ast) {
    return ast[0];
  }), (0, _.chain)(['enum', 'set'])(function (ast) {
    return ast[0];
  }), (0, _.chain)('geometrycollection', 'linestring', 'multilinestring', 'multipoint', 'multipolygon', 'point', 'polygon')(function (ast) {
    return ast[0];
  })])(function (ast) {
    return ast[0];
  });
};

exports.dataType = dataType;

var setValue = function setValue() {
  return (0, _.chain)(wordSym, '=', [stringSym, numberSym])();
};

exports.setValue = setValue;

var setValueList = function setValueList() {
  return (0, _.chain)(setValue, (0, _.many)(',', setValue))();
};

exports.setValueList = setValueList;

var wordSym = function wordSym() {
  return (0, _.chain)([(0, _.matchTokenType)('cursor'), (0, _.matchTokenType)('word', {
    excludes: _reserveKeys.reserveKeys
  })])(function (ast) {
    return ast[0];
  });
};

exports.wordSym = wordSym;

var stringSym = function stringSym() {
  return (0, _.chain)((0, _.matchTokenType)('string'))(function (ast) {
    return ast[0];
  });
};

exports.stringSym = stringSym;

var numberSym = function numberSym() {
  return (0, _.chain)((0, _.matchTokenType)('number'))(function (ast) {
    return ast[0];
  });
};

exports.numberSym = numberSym;

var stringOrWord = function stringOrWord() {
  return (0, _.chain)([wordSym, stringSym])(function (ast) {
    return ast[0];
  });
};

exports.stringOrWord = stringOrWord;

var stringOrWordOrNumber = function stringOrWordOrNumber() {
  return (0, _.chain)([wordSym, stringSym, numberChain])(function (ast) {
    return ast[0];
  });
};

exports.stringOrWordOrNumber = stringOrWordOrNumber;

var numberChain = function numberChain() {
  return (0, _.chain)((0, _.optional)(['-', '+']), numberSym)();
};

exports.numberChain = numberChain;

var logicalOperator = function logicalOperator() {
  return (0, _.chain)(['and', '&&', 'xor', 'or', '||'])(function (ast) {
    return ast[0];
  });
};

exports.logicalOperator = logicalOperator;

var normalOperator = function normalOperator() {
  return (0, _.chain)(['&&', '||'])(function (ast) {
    return ast[0];
  });
};

exports.normalOperator = normalOperator;

var comparisonOperator = function comparisonOperator() {
  return (0, _.chain)(['=', '>', '<', '<=', '>=', '<>', '!=', '<=>'])(function (ast) {
    return ast[0];
  });
};

exports.comparisonOperator = comparisonOperator;

var notOperator = function notOperator() {
  return (0, _.chain)(['not', '!'])(function (ast) {
    return ast[0];
  });
};

exports.notOperator = notOperator;

var selectSpec = function selectSpec() {
  return (0, _.chain)(['all', 'distinct', 'distinctrow', 'high_priority', 'straight_join', 'sql_small_result', 'sql_big_result', 'sql_buffer_result', 'sql_cache', 'sql_no_cache', 'sql_calc_found_rows'])(function (ast) {
    return ast[0];
  });
};

exports.selectSpec = selectSpec;